// Local Constants
import { RESET_STATE } from '../auth/constants';
import { WORKSHEET_SET } from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import { WorksheetState, WorksheetActions } from './types';

const initialState = {};

export default function (
    state: WorksheetState = initialState,
    action: WorksheetActions | ResetStateAction
): WorksheetState {
    switch (action.type) {
        case WORKSHEET_SET:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
